import { IAttribute, IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { format, getConnectorV2Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';

export enum SalesforceAuthTypes {
    OAuth = 'OAuth2ClientCredential'
}

@Metamodel.model({
    name: ModelConstants.salesforceV2LinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, getConnectorV2Name(shellStringResources.Salesforce_DisplayText, isTridentInIframe())),
        format(shellStringResources.ModelName_LinkedServicesTemplate, getConnectorV2Name(shellStringResources.Salesforce_DisplayText, isTridentInIframe()))
    ]
})
export class SalesforceV2LinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public static readonly ENVIRONMENT_URL: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly CLIENT_SECRET: IAttribute;
    public static readonly API_VERSION: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_EnvironmentUrl,
        association: 'ENVIRONMENT_URL',
        templatable: true
    })
    public environmentUrl?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AuthenticationType
    })
    public authenticationType?: SalesforceAuthTypes = SalesforceAuthTypes.OAuth;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ClientSecret,
        association: 'CLIENT_SECRET',
        templatable: true
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SalesforceApiVersion,
        association: 'API_VERSION',
        templatable: true
    })
    public apiVersion?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): SalesforceV2LinkedService {
        return this;
    }
}
